import React, { FC, PropsWithChildren } from "react"
import s from "./styles.module.css"

const Container: FC<PropsWithChildren> = ({ children }: PropsWithChildren) => {
  return <div className={s.container}>{children}</div>
}

export default Container
